import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";

export const getBookmarks = defineQuery("getBookmarks", {
  input: z.object({}),
  handler: async ({ db }) => {
    const { data, error } = await db
      .from("bookmarks")
      .select("*")
      .order("created_at", { ascending: false });
    if (error) throw error;
    return data;
  },
});

export const getDocBookmark = defineQuery("getDocBookmark", {
  input: z.object({ table_name: z.string(), content_id: z.string() }),
  handler: async ({ db }, { table_name, content_id }) => {
    const { data, error } = await db
      .from("bookmarks")
      .select("*")
      .eq("table_name", table_name)
      .eq("content_id", content_id)
      .is("page_number", null)
      .maybeSingle();
    if (error) throw error;
    return data;
  },
});

export const getPdfBookmarks = defineQuery("getPdfBookmarks", {
  input: z.object({
    table_name: z.string(),
    content_id: z.string(),
  }),
  handler: async ({ db }, { table_name, content_id }) => {
    const { data, error } = await db
      .from("bookmarks")
      .select("*")
      .eq("table_name", table_name)
      .eq("content_id", content_id)
      .order("page_number", { ascending: true });
    if (error) throw error;
    return data;
  },
});
